import CreatorPublicationPage from "./CreatorPublicationPage";

export default CreatorPublicationPage;
